// Columns of the API Costs tables. Token columns stay separate but sit under two
// header groups: In (prompt) and Out (answer + thinking; Gemini bills thinking
// tokens at the output price). Cost shows the total and the average per call.

export interface UsageMetrics {
  calls: number;
  prompt: number;
  output: number;
  thoughts: number;
  cost: number;
}

export type MetricKey = keyof UsageMetrics | "per_call";

export const METRIC_COLS: { key: MetricKey; label: string; group?: string }[] = [
  { key: "calls",    label: "Calls" },
  { key: "prompt",   label: "Prompt",   group: "In" },
  { key: "output",   label: "Answer",   group: "Out" },
  { key: "thoughts", label: "Thinking", group: "Out" },
  { key: "cost",     label: "Total",    group: "Cost" },
  { key: "per_call", label: "Per call", group: "Cost" },
];

// Upper header row: a group spans its columns; a column without a group spans
// both header rows under its own label.
export const headerGroups = (cols = METRIC_COLS) => {
  const out: { label: string; colSpan: number; group: boolean }[] = [];
  for (const c of cols) {
    const last = out[out.length - 1];
    if (c.group && last?.group && last.label === c.group) last.colSpan += 1;
    else out.push(c.group ? { label: c.group, colSpan: 1, group: true } : { label: c.label, colSpan: 1, group: false });
  }
  return out;
};

export const metricValue = (m: UsageMetrics, key: MetricKey): number =>
  key === "per_call" ? (m.calls ? m.cost / m.calls : 0) : m[key];

// Swiss thousand separator: 334'143
export const fmtNum = (n: number) =>
  Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");

// Four decimals: a single call often costs a fraction of a cent. Input in micros.
export const fmtUsdPerCall = (micros: number) => `$${(micros / 1_000_000).toFixed(4)}`;
